__turbopack_context__.v({
  "label": "SingleDropdown-module__g4gw4q__label",
  "optionsContainer": "SingleDropdown-module__g4gw4q__optionsContainer",
  "optionsList": "SingleDropdown-module__g4gw4q__optionsList",
});
